import { render } from "./audits.vue?vue&type=template&id=f8b3902c&scoped=true"
import script from "./audits.vue?vue&type=script&lang=js"
export * from "./audits.vue?vue&type=script&lang=js"

import "./audits.vue?vue&type=style&index=0&id=f8b3902c&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8b3902c"]])

export default __exports__